import React from 'react';
import { DimensionValue, StyleProp, View, ViewStyle } from 'react-native';

import { Skeleton, SkeletonProps } from './skeleton';
import { flex } from '../../style-utils';

type SkeletonListProps = {
  containerStyle?: StyleProp<ViewStyle>;
  orientation?: 'horizontal' | 'vertical';
  skeletons: {
    height: DimensionValue;
    width: DimensionValue;
  }[];
} & Pick<SkeletonProps, 'backgroundColor' | 'gradientColor' | 'style'>;

export const SkeletonList: React.FC<SkeletonListProps> = ({
  containerStyle,
  skeletons,
  orientation = 'horizontal',
  ...props
}) => {
  const styles =
    orientation === 'horizontal'
      ? flex('flex-row', 'align-items-center')
      : flex('flex-column', 'align-items-start');

  return (
    <View style={[flex('justify-content-between'), styles, containerStyle]}>
      {skeletons.map(({ height, width }, index) => (
        <Skeleton key={index} height={height} width={width} {...props} />
      ))}
    </View>
  );
};
